import { defer, tap, map, startWith, type Observable } from 'rxjs';
import { api, componentTypeApi, wrapUncaughtErrors } from '@ardoq/api';
import { shareSWR } from '@ardoq/rxbeach';
import type { ApiComponentTypeOverviewRow } from '@ardoq/api-types';
import { LOADING, type Result } from '@ardoq/common-helpers';

const overviewRequest$: Observable<Result<ApiComponentTypeOverviewRow[]>> =
  defer(componentTypeApi.fetchComponentTypeOverview).pipe(
    wrapUncaughtErrors(),
    tap(response => api.logErrorIfNeeded(response)),
    shareSWR()
  );

export const componentTypeOverview$ = overviewRequest$.pipe(
  map(response => api.defaultValueIfError(response, [])),
  startWith(LOADING)
);
